import { call, put } from "redux-saga/effects";
import * as SagaTypes from "./saga-types";

import {
  claimChatByAgentFailure,
  claimChatByAgentRequest,
  claimChatByAgentSuccess,
} from "../actions";
import { urls } from "../constants/constants";
import * as Api from "../api";

export function* convertClosedToActiveChat(action) {
  yield put(claimChatByAgentRequest());

  const patientId = action.payload.param.patientId;

  try {
    const result = yield call(
      Api.get,
      `${urls.aspariaBackend}api/v1/livechat-agent/activateChat/${patientId}`
    );
    if (result) {
      action.callback();
      yield put(claimChatByAgentSuccess(result.data.data));
    } else {
      yield put(claimChatByAgentFailure("Something went Wrong"));
    }
  } catch (e) {
    yield put(claimChatByAgentFailure(e));
  }
}

export const openChatByAgent = (param, cb) => ({
  type: SagaTypes.CONVERT_CLOSED_CHAT_TO_ACTIVE_CHAT,
  payload: { param },
  callback: cb,
});
